import { fmtCurrency } from "../../utils";

export default function ReceiptTableOrder({ translate, lang, items, payment }) {
	return (
		<table>
			<thead>
				<tr>
					<th className="left">
						{translate(lang, `Descripción`, `Descripción`)}
					</th>
					<th>{translate(lang, `Total`, `Total`)}</th>
				</tr>
			</thead>
			<tbody>
				{items.map((item, index) => {
					return item.type === "item" ? (
						<tr key={index}>
							<td>{item.description}</td>
							<td className="right">{fmtCurrency(item.amount / 100)}</td>
						</tr>
					) : item.type === "discount" ? (
						<tr
							key={index}
							style={{ display: item.amount > 0 ? "table-row" : "none" }}
						>
							<th className="right">{item.description}</th>
							<th className="right" style={{ color: "red" }}>
								({fmtCurrency(item.amount / 100)})
							</th>
						</tr>
					) : (
						<tr key={index}>
							<th className="right">{item.description}</th>
							<th className="right">{fmtCurrency(item.amount / 100)}</th>
						</tr>
					);
				})}
				<tr>
					<th className="right">{payment.descr}</th>
					<th className="right">{payment.amt}</th>
				</tr>
			</tbody>
		</table>
	);
}
